import { createContext } from 'react';

export const InteractiveCodeContext = createContext<{
  codeBlockIndex: number;
  files: string[];
  setCodeBlockIndex(index: number): void;
}>({
  codeBlockIndex: 0,
  files: [],
  setCodeBlockIndex: () => null,
});
